import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Request from "../../components/api/Request";
import { Button } from "devextreme-react/button";
import TextBox from "devextreme-react/text-box";
import { CheckBox } from 'devextreme-react/check-box';
import { Popup } from 'devextreme-react/popup';
import TesvikSgkLogin from "./TesvikSgkLogin";
import * as AppActions from '../../actions/AppActions';
import { showDialog } from "../../utils/Utils";

const CariDonemLoginIslemleri = (props) => {
  const dispatch = useDispatch();
 
 
  const [dataInfo, setDataInfo] = useState({
    donemAdi: "",
    domainId: props.data.domain.id,
    domainAdi: props.data.domain.name, 
    donem: props.data.cariDonem.donem,    
    oncekiDonem: props.data.oncekiDonem.donem,  
    

    oncekiDonemTesvikSorgu: !(props.data.donemTesvikBilgi != null && props.data.donemTesvikBilgi.oncekiDonemTesvikSorguZamani != null),
    cariDonemTesvikSorgu: !(props.data.donemTesvikBilgi != null && props.data.donemTesvikBilgi.cariDonemTesvikSorguZamani != null),
    tesvikKayit: !(props.data.donemTesvikBilgi != null && props.data.donemTesvikBilgi.tesvikOnayZamani != null),
    onayliTesvikGuncelle: !(props.data.donemTesvikBilgi != null && props.data.donemTesvikBilgi.onayliTesvikListeGuncellemeZamani != null),
    muhtasarOnayliIndir: !(props.data.donemTesvikBilgi != null && props.data.donemTesvikBilgi.dataAktarimZamani != null),
     

    isverenSistemLogin: false,
    issizlikSistemLogin: false,
    isbasiSistemLogin: false,
    bildirgeSistemiLogin: false,
    tesvikKanalSayisi :1,
    tesvikKanalSiradakiLoginOlmamis:1
  });

  const [loginData, setLoginData] = useState({ popupState: false, data: {} });
 


  useEffect(() => {
    if(dataInfo != null && dataInfo.domainId != null){
      setButtonState();
    }   
  }, []);

  function setButtonState() {

    dispatch(AppActions.setLoading(true, "Teşvik servisi login bilgileri alınıyor.."));
    const request = new Request("/tesvikIslemleri/isLogin/" + dataInfo.domainId, "GET");
    request.run()
      .then(response => {
        if (response.data.success == true) {
          setDataInfo(Object.assign({}, dataInfo, {
            isverenSistemLogin: response.data.data.isveren,
            issizlikSistemLogin: response.data.data.issizlik,
            isbasiSistemLogin: response.data.data.isbasi,
            bildirgeSistemiLogin: response.data.data.bildirge,
            tesvikKanalSayisi: response.data.data.tesvikKanalSayisi,
            tesvikKanalSiradakiLoginOlmamis: response.data.data.tesvikKanalSiradakiLoginOlmamis,
          }));

          if(props.data.islem == 'login' ){
            if(response.data.data.isveren  && response.data.data.issizlik && response.data.data.isbasi  && response.data.data.bildirge){
              dispatch(AppActions.setLoading(false, ""));
              props.hide();
            }
          }
        }
        dispatch(AppActions.setLoading(false, ""));

      })
      .catch(() => {
        dispatch(AppActions.setLoading(false, ""));
      });
  }



  function hideTesvikIslemleriPopup() {
    setLoginData({ popupState: false, data: {} })
    setButtonState();
  }
  function showIsverenLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: dataInfo.domainId, sistem: "isveren" }
    });
  }
  function showIssizlikLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: dataInfo.domainId, sistem: "issizlik" }
    });
  }
  function showIsbasLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: dataInfo.domainId, sistem: "isbasi" }
    });
  }

  function showBildirgeLoginPopup() {
    setLoginData({
      popupState: true,
      data: { domainId: dataInfo.domainId, sistem: "bildirge" }
    });
  }

  function onOncekiDonemTesvikkSorguValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { oncekiDonemTesvikSorgu: args.value }));
  }
  function onCariDonemTesvikkSorguValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { cariDonemTesvikSorgu: args.value }));
  }
  function onTesvikKayitValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { tesvikKayit: args.value }));
  }
  function onOnayliTesvikGuncelleValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { onayliTesvikGuncelle: args.value }));
  }
  function onMuhtasarOnayBekleyenBelgeValueChanged(args) {
    setDataInfo(Object.assign({}, dataInfo, { muhtasarOnayliIndir: args.value }));
  }
  function islemBaslat() {
    servisIslemBaslat(dataInfo.oncekiDonemTesvikSorgu,dataInfo.cariDonemTesvikSorgu,dataInfo.tesvikKayit,dataInfo.onayliTesvikGuncelle,dataInfo.muhtasarOnayliIndir);
  }

  function servisIslemBaslat(oncekiDonemTesvikSorgu,cariDonemTesvikSorgu,tesvikKayit,onayliTesvikGuncelle,muhtasarOnayliIndir) {

    if(oncekiDonemTesvikSorgu == true){
      dispatch(AppActions.setLoading(true, dataInfo.oncekiDonem + " Dönemi İndiriliyor.."));
      const request = new Request("/cariDonemTesvikRapor/oncekiDonemIndir/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
          servisIslemBaslat(false,cariDonemTesvikSorgu,tesvikKayit,onayliTesvikGuncelle,muhtasarOnayliIndir);
        }else if(response && response.response && response.response.data ){
          let message  =response.response.data.message;
          showDialog({ title: 'Dönem Hata', message: message, buttons: "OK" });
        }
      });
    }else if(cariDonemTesvikSorgu == true){
      dispatch(AppActions.setLoading(true, dataInfo.donem + " Dönemi İndiriliyor.."));
      const request = new Request("/cariDonemTesvikRapor/cariDonemIndir/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
          servisIslemBaslat(oncekiDonemTesvikSorgu,false,tesvikKayit,onayliTesvikGuncelle,muhtasarOnayliIndir);
        }else if(response && response.response && response.response.data ){
          let message  =response.response.data.message;
          showDialog({ title: 'Dönem Hata', message: message, buttons: "OK" });
        }
      });
    } else if(tesvikKayit == true){
      dispatch(AppActions.setLoading(true, "Onaysız Teşvik Kayıt İşlemi Yapılıyor.."));
      const request = new Request("/cariDonemTesvikRapor/saveTesvikSgk/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));

        //burada özel durum var onaysız teşvik olmayabilir
        if (response && response.data ) {
          servisIslemBaslat(oncekiDonemTesvikSorgu,cariDonemTesvikSorgu,false,onayliTesvikGuncelle,muhtasarOnayliIndir);
        }else if(response && response.response && response.response.data ){
          let message  =response.response.data.message;
          showDialog({ title: 'Dönem Hata', message: message, buttons: "OK" });
        }
      });
    } else if(onayliTesvikGuncelle == true){
      dispatch(AppActions.setLoading(true, "Onaylı Dönem Teşvik Listesi Güncelleniyor.."));
      const request = new Request("/cariDonemTesvikRapor/onayliDonemIndir/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));
        if (response && response.data && response.data.data === true) {
          servisIslemBaslat(oncekiDonemTesvikSorgu,cariDonemTesvikSorgu,tesvikKayit,false,muhtasarOnayliIndir);
        }else if(response && response.response && response.response.data ){
          let message  =response.response.data.message;
          showDialog({ title: 'Dönem Hata', message: message, buttons: "OK" });
        }
      });
    } else if(muhtasarOnayliIndir == true){
      dispatch(AppActions.setLoading(true, "Muhtasar Onay Bekleyen Dönem İndiriliyor.."));
      const request = new Request("/cariDonemTesvikRapor/donemIndirMuhtasarOnayBekleyen/" + dataInfo.domainId ,"GET");
      request.run().then((response) => {

        dispatch(AppActions.setLoading(false, ""));
           //burada özel durum var onay bekleyen belge olmayabilir
        if (response && response.data) {
          servisIslemBaslat(oncekiDonemTesvikSorgu,cariDonemTesvikSorgu,tesvikKayit,onayliTesvikGuncelle,false);
        }else if(response && response.response && response.response.data ){
          let message  =response.response.data.message;
          showDialog({ title: 'Dönem Hata', message: message, buttons: "OK" });
        }
      });
    }else{
      props.hide();
    }
  }


  return (
    <React.Fragment>

      <TextBox readOnly={true} hoverStateEnabled={false} value={dataInfo.domainAdi}/>
      <br></br>
      <TextBox readOnly={true} hoverStateEnabled={false} value= {"CariDönem: "+ dataInfo.donem} />
      <br></br>

      <CheckBox value={dataInfo.oncekiDonemTesvikSorgu} width={300} text="Önceki Dönem Teşvik Sorgu" onValueChanged={onOncekiDonemTesvikkSorguValueChanged} />
      <br></br>
      <CheckBox value={dataInfo.cariDonemTesvikSorgu} width={300} text="Cari Dönem Teşvik Sorgu" onValueChanged={onCariDonemTesvikkSorguValueChanged} />
      <br></br>
      <CheckBox value={dataInfo.tesvikKayit} width={300} text="Teşvik Kayıt" onValueChanged={onTesvikKayitValueChanged} />
      <br></br>
      <CheckBox value={dataInfo.onayliTesvikGuncelle} width={300} text="Onaylı Teşvik Listesi Güncelle" onValueChanged={onOnayliTesvikGuncelleValueChanged} />
      <br></br>
      <CheckBox value={dataInfo.muhtasarOnayliIndir} width={300} text="Muhtasar Onay Bekleyen Belge Indir" onValueChanged={onMuhtasarOnayBekleyenBelgeValueChanged} />
      <br></br>

      <Button width={300} text={"İşveren Sistemi Giriş (" + dataInfo.tesvikKanalSiradakiLoginOlmamis + "/" + dataInfo.tesvikKanalSayisi+")"}  type="danger" stylingMode="contained"
        visible={!dataInfo.isverenSistemLogin}
        onClick={showIsverenLoginPopup} />

      <Button width={300} text="İssizlik Sistemi Giriş" type="danger" stylingMode="contained"
        visible={!dataInfo.issizlikSistemLogin}
        onClick={showIssizlikLoginPopup}/>
      <Button width={300} text="İşbaşı Sistemi Giriş" type="danger" stylingMode="contained"
        visible={!dataInfo.isbasiSistemLogin}
        onClick={showIsbasLoginPopup}/>
      <Button width={300} text="Bildirge Sistemi Giriş" type="danger" stylingMode="contained"
        visible={!dataInfo.bildirgeSistemiLogin}
        onClick={showBildirgeLoginPopup}/>

      <br></br>
      <Button
        width={300}
        text={"İşlem Başlat"}
        type="success"
        stylingMode="contained"
        visible={dataInfo.isverenSistemLogin && dataInfo.issizlikSistemLogin && dataInfo.isbasiSistemLogin && dataInfo.bildirgeSistemiLogin }
        onClick={islemBaslat}
      />


      <Popup
        visible={loginData.popupState}
        onHiding={hideTesvikIslemleriPopup}
        dragEnabled={false}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Sgk Login işlemleri"
        width={300}
        height={200}
      >
        <div>
          {loginData.popupState ? <TesvikSgkLogin data={loginData.data} hide={hideTesvikIslemleriPopup} /> : null}
        </div>
      </Popup>

    </React.Fragment>
  );
};

export default CariDonemLoginIslemleri;

